<template>
    <div>
        <div ref='dynamic'></div>
        <slot>

        </slot>
    </div>
</template>
<script>
export default {
  name: 'dynamic',
  props: {

  },
  data () {
    return {
    }
  },
  methods: {
    async destroyUi () {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  beforeDestroy () {
    this.childInstance.$destroy(true)
  }

}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/plugins/dynamic/Dynamic.vue